/* [BD] Ingredients nutrition table drawer */
;(function () {
  var DEBUG = window.BD_NUTRITION_DEBUG === true;

  function debugLog() {
    if (!DEBUG) return;
    var args = Array.prototype.slice.call(arguments);
    args.unshift('[BD Nutrition]');
    console.log.apply(console, args);
  }

  function debugWarn() {
    if (!DEBUG) return;
    var args = Array.prototype.slice.call(arguments);
    args.unshift('[BD Nutrition]');
    console.warn.apply(console, args);
  }

  function collectHostDiagnostics(host) {
    if (!host) return { error: 'host is null' };

    var detailsModal = host.querySelector('details-modal');
    var details = host.querySelector('details');
    var panels = host.querySelectorAll('[data-bd-nutrition-panel]');
    var panelInfo = [];

    panels.forEach(function (panel) {
      var table = panel.querySelector('.bd-nutrition-table');
      var rows = panel.querySelectorAll('.bd-nutrition-table__row');
      var head = panel.querySelector('.bd-nutrition-table__head');
      panelInfo.push({
        id: panel.getAttribute('data-bd-nutrition-panel'),
        variantId: panel.getAttribute('data-bd-nutrition-variant-id'),
        hidden: panel.hasAttribute('hidden'),
        isActive: panel.classList.contains('is-active'),
        display: window.getComputedStyle(panel).display,
        rowCount: rows.length,
        hasTable: Boolean(table),
        headText: head ? head.textContent.replace(/\s+/g, ' ').trim().slice(0, 120) : '',
      });
    });

    return {
      hostId: host.id,
      sectionId: host.getAttribute('data-bd-nutrition-section-id'),
      openOnLoad: host.getAttribute('data-bd-nutrition-open-on-load'),
      defaultPanel: host.getAttribute('data-bd-nutrition-default-panel'),
      hasDetailsModal: Boolean(detailsModal),
      detailsOpen: details ? details.hasAttribute('open') : null,
      detailsOpeningClass: details ? details.classList.contains('bd-search-modal-opening') : null,
      panelCount: panels.length,
      panels: panelInfo,
      bodyOverflowHidden: document.body.classList.contains('overflow-hidden'),
    };
  }

  function activateNutritionPanel(host, panelId) {
    if (!host || !panelId) {
      debugWarn('activateNutritionPanel: missing host or panelId', { host: Boolean(host), panelId: panelId });
      return false;
    }

    var matched = false;
    host.querySelectorAll('[data-bd-nutrition-panel]').forEach(function (panel) {
      var active = panel.getAttribute('data-bd-nutrition-panel') === panelId;
      if (active) matched = true;
      panel.classList.toggle('is-active', active);
      if (active) {
        panel.removeAttribute('hidden');
      } else {
        panel.setAttribute('hidden', '');
      }
    });

    debugLog('activateNutritionPanel', { panelId: panelId, matched: matched });
    return matched;
  }

  function openNutritionModal(sectionId, panelId, source) {
    debugLog('——— openNutritionModal ———', { source: source || 'unknown', sectionId: sectionId, panelId: panelId });

    var hostId = 'BdNutritionModal-' + sectionId;
    var host = document.getElementById(hostId);

    if (!host) {
      debugWarn('HOST NOT FOUND', hostId);
      debugLog('All nutrition hosts on page:', Array.prototype.map.call(
        document.querySelectorAll('.bd-ingredients-nutrition-modal-host'),
        function (h) {
          return { id: h.id, sectionId: h.getAttribute('data-bd-nutrition-section-id') };
        }
      ));
      return { ok: false, reason: 'host-not-found', hostId: hostId };
    }

    debugLog('Host diagnostics (before open):', collectHostDiagnostics(host));

    var panelMatched = activateNutritionPanel(host, panelId);
    if (!panelMatched) {
      debugWarn('PANEL ID NOT FOUND on host', {
        requestedPanelId: panelId,
        availablePanels: Array.prototype.map.call(
          host.querySelectorAll('[data-bd-nutrition-panel]'),
          function (p) {
            return p.getAttribute('data-bd-nutrition-panel');
          }
        ),
      });
    }

    var detailsModal = host.querySelector('details-modal');
    if (!detailsModal) {
      debugWarn('details-modal element missing inside host');
      return { ok: false, reason: 'no-details-modal' };
    }

    var summary = detailsModal.querySelector('summary');
    if (!summary) {
      debugWarn('summary missing inside details-modal');
      return { ok: false, reason: 'no-summary' };
    }

    var alreadyOpen = typeof detailsModal.isOpen === 'function' && detailsModal.isOpen();
    debugLog('details-modal state', {
      alreadyOpen: alreadyOpen,
      hasOpenMethod: typeof detailsModal.open === 'function',
    });

    if (alreadyOpen) {
      debugLog('Modal already open — panel swap only');
      debugLog('Host diagnostics (already open):', collectHostDiagnostics(host));
      return { ok: true, reason: 'already-open' };
    }

    try {
      if (typeof detailsModal.open === 'function') {
        detailsModal.open({ target: summary });
        debugLog('Called detailsModal.open({ target: summary })', { returnFocus: Boolean(openerBtn) });
      } else {
        summary.click();
        debugLog('Fallback: summary.click()');
      }
    } catch (err) {
      debugWarn('open failed with error', err);
      return { ok: false, reason: 'open-threw', error: String(err) };
    }

    window.setTimeout(function () {
      debugLog('Host diagnostics (~100ms after open):', collectHostDiagnostics(host));
    }, 100);

    return { ok: true, reason: 'opened' };
  }

  function bindTriggers(scope) {
    var root = scope || document;
    var triggers = root.querySelectorAll('[data-bd-nutrition-trigger]');

    debugLog('bindTriggers', {
      scope: scope === document ? 'document' : scope.id || scope.className || 'element',
      triggerCount: triggers.length,
    });

    triggers.forEach(function (btn, index) {
      if (btn.dataset.bdNutritionTriggerBound) return;
      btn.dataset.bdNutritionTriggerBound = '1';

      debugLog('Bound trigger #' + (index + 1), {
        sectionId: btn.getAttribute('data-bd-nutrition-section'),
        panelId: btn.getAttribute('data-bd-nutrition-panel'),
        disabled: btn.disabled,
        text: btn.textContent.trim(),
      });

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        debugLog('BUTTON CLICK', {
          sectionId: btn.getAttribute('data-bd-nutrition-section'),
          panelId: btn.getAttribute('data-bd-nutrition-panel'),
          defaultPrevented: e.defaultPrevented,
        });
        var result = openNutritionModal(
          btn.getAttribute('data-bd-nutrition-section'),
          btn.getAttribute('data-bd-nutrition-panel'),
          'button-click'
        );
        debugLog('openNutritionModal result:', result);
      });
    });

    root.querySelectorAll('.bd-ingredients-nutrition-modal-host').forEach(function (host) {
      initOpenOnLoad(host);
      debugLog('Modal host on page:', collectHostDiagnostics(host));
    });
  }

  function initOpenOnLoad(host) {
    if (!host || host.dataset.bdNutritionOpenOnLoadInit) return;
    if (host.getAttribute('data-bd-nutrition-open-on-load') !== 'true') return;
    host.dataset.bdNutritionOpenOnLoadInit = '1';

    var sectionId = host.getAttribute('data-bd-nutrition-section-id') || host.id.replace('BdNutritionModal-', '');
    var panelId = host.getAttribute('data-bd-nutrition-default-panel');
    var firstPanel = host.querySelector('[data-bd-nutrition-panel]');
    if (!panelId && firstPanel) {
      panelId = firstPanel.getAttribute('data-bd-nutrition-panel');
    }
    if (!firstPanel) {
      debugWarn('initOpenOnLoad: no panels in host', host.id);
      return;
    }

    debugLog('initOpenOnLoad', { sectionId: sectionId, panelId: panelId });

    var runOpen = function () {
      openNutritionModal(sectionId, panelId, 'open-on-load');
    };

    if (customElements.get('details-modal')) {
      requestAnimationFrame(function () {
        requestAnimationFrame(runOpen);
      });
    } else {
      customElements.whenDefined('details-modal').then(function () {
        requestAnimationFrame(function () {
          requestAnimationFrame(runOpen);
        });
      });
    }
  }

  function onReady() {
    if (DEBUG) {
      console.log(
        '[BD Nutrition] Debug logging is ON. Copy output after clicking "Alle Nährstoffe".\n' +
          '  Disable: window.BD_NUTRITION_DEBUG = false  (then reload)\n' +
          '  Or run: copy(JSON.stringify(window.bdNutritionDebugReport(), null, 2))'
      );
    }
    bindTriggers(document);
  }

  window.bdNutritionDebugReport = function () {
    var hosts = document.querySelectorAll('.bd-ingredients-nutrition-modal-host');
    var triggers = document.querySelectorAll('[data-bd-nutrition-trigger]');
    return {
      debugEnabled: DEBUG,
      url: typeof window.location !== 'undefined' ? window.location.href : '',
      triggerCount: triggers.length,
      triggers: Array.prototype.map.call(triggers, function (btn) {
        return {
          sectionId: btn.getAttribute('data-bd-nutrition-section'),
          panelId: btn.getAttribute('data-bd-nutrition-panel'),
          disabled: btn.disabled,
          label: btn.textContent.trim(),
        };
      }),
      hosts: Array.prototype.map.call(hosts, collectHostDiagnostics),
    };
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }

  if (window.Shopify && window.Shopify.designMode && !window.__bdIngredientsNutritionModalDesignMode) {
    window.__bdIngredientsNutritionModalDesignMode = true;
    document.addEventListener('shopify:section:load', function (e) {
      if (e.target) bindTriggers(e.target);
    });
  }
})();
